import React, { useEffect, useState } from 'react'
import {
  Route,
  Navigate,
  createRoutesFromElements,
  createBrowserRouter,
  RouterProvider
} from 'react-router-dom'

import PublicNavbar from './PublicNavbar'
import PublicSimpleBoardPage from './PublicSimpleBoardPage'
import PublicDetailedBoardPage from './PublicDetailedBoardPage'
import PublicSubmissionsPage from './PublicSubmissionsPage'
import PublicPlayersPage from './PublicPlayersPage'

import CtrlPanelNavBar from './controlPanel/CtrlPanelNavbar'
import CtrlPanelPage from './controlPanel/CtrlPanelPage'
// import CtrlPanelFourPlayerDetailedPage from './controlPanel/CtrlPanelFourPlayerDetailedPage'
// import CtrlPanelFivePlayerPage from './controlPanel/CtrlPanelFivePlayerPage'
// import CtrlPanelSummaryPage from './controlPanel/CtrlPanelSummaryPage'

import { useStore } from '../zustandStore'
import { shallow } from 'zustand/shallow'

export const routes = (event) => createRoutesFromElements(<>
  <Route path='/controlpanel' element={<CtrlPanelNavBar />}>
    <Route path='' element={<CtrlPanelPage />} />

    <Route path='*' element={<Navigate to='/controlpanel' replace />} />
  </Route>

  {/* redirect from old paths */}
  <Route path='/simple' element={
    <Navigate to='/current/simple' replace />
  } />
  <Route path='/detailed' element={
    <Navigate to='/current/detailed' replace />
  } />
  <Route path='/submissions' element={
    <Navigate to='/current/submissions' replace />
  } />
  <Route path='/players' element={
    <Navigate to='/current/players' replace />
  } />

  <Route path='/:eventSlug' element={<PublicNavbar />} >

    <Route path='simple' element={<PublicSimpleBoardPage />} />
    {!event.isFullGame &&
      <Route path='detailed' element={<PublicDetailedBoardPage />} />
    }
    {!event.isBingo &&
      <Route path='submissions' element={<PublicSubmissionsPage />} />
    }

    <Route path='players' element={<PublicPlayersPage />} />
    <Route path='players/:playerSlug' element={<PublicPlayersPage />} />

    <Route path=''  element={<Navigate to='simple' replace />} />
    <Route path='*' element={<Navigate to='simple' replace />} />
  </Route>

  <Route path='' element={
    <Navigate to='/current/simple' replace />
  }/>

  {/* <Route path='*' element={<Navigate to='/simple' replace />} /> */}
</>)

const PublicRouter = (props) => {
  // isLoading determines whether the spinner is showing and locking you out
  // hasSentUpdate determines whether it was *this* client's update that caused the new data, because we only clear the staged data if so
  // const [isLoading,     setIsLoading]     = useState(false)
  // const [hasSentUpdate, setHasSentUpdate] = useState(false)

  const { obsState, setIsLoading, setHasSentUpdate } = useStore(
    state => ({
      obsState:         state.obsState,
      setIsLoading:     state.setIsLoading,
      setHasSentUpdate: state.setHasSentUpdate
    }),
    shallow
  )
  const [isInitialRender, setIsInitialRender] = useState(true)
  useEffect(() => {
    if (!isInitialRender) {
      setIsLoading(true)
      setTimeout(() => {
        setIsLoading(false)
        setHasSentUpdate(false)
      },
      (obsState.updatesAvailableInSec * 1000) + 250)
    } else {
      setIsInitialRender(false)
    }
  }, [obsState.loadedAtMs])

  const event = useStore(state => state.event)

  const router = createBrowserRouter(routes(event))

  return <RouterProvider router={router} />
}

export default PublicRouter
